var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupOfPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59279 9.80548C8.50946 9.79715 8.40946 9.79715 8.31779 9.80548C6.33446 9.73882 4.75946 8.11382 4.75946 6.11382C4.75946 4.07215 6.40946 2.41382 8.45946 2.41382C10.5011 2.41382 12.1595 4.07215 12.1595 6.11382C12.1511 8.11382 10.5761 9.73882 8.59279 9.80548Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6345 4.08032C16.2511 4.08032 17.5511 5.38866 17.5511 6.99699C17.5511 8.57199 16.3011 9.85532 14.7428 9.91366C14.6761 9.90532 14.6011 9.90532 14.5261 9.91366",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42614 12.8803C2.40947 14.2303 2.40947 16.4303 4.42614 17.772C6.7178 19.3053 10.4761 19.3053 12.7678 17.772C14.7845 16.422 14.7845 14.222 12.7678 12.8803C10.4845 11.3553 6.72614 11.3553 4.42614 12.8803Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2428 17.4138C16.8428 17.2888 17.4095 17.0472 17.8761 16.6888C19.1761 15.7138 19.1761 14.1055 17.8761 13.1305C17.4178 12.7805 16.8595 12.5472 16.2678 12.4138",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupOfPeople);
export default __webpack_public_path__ + "static/media/group-of-people.88b62c55751d3bbf93324e9cf14c3e4d.svg";
export { ForwardRef as ReactComponent };